var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSquarePlusIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.5 8v8m4-4h-8M3 12c0-4.478 0-6.718 1.391-8.109S8.021 2.5 12.5 2.5c4.478 0 6.718 0 8.109 1.391S22 7.521 22 12c0 4.478 0 6.718-1.391 8.109S16.979 21.5 12.5 21.5c-4.478 0-6.718 0-8.109-1.391S3 16.479 3 12"
}))));
export { SvgSquarePlusIcon as ReactComponent };
export default __webpack_public_path__ + "63099c2d749599be4cd2ac8de48de75b.svg";